import React from 'react'
import { IconButtons } from '../ui-components'
import Card from "../components/Card";
import { Button } from "@aws-amplify/ui-react";
import LeadsUpdateForm from './LeadsUpdateForm';


function UpdateLeadForm({onToggleTab, assingLead, user, userName}) {

  return (
    <div className="mt-16">
      <Card
      textTitle="Asignar Lead"
      classNameBody="py-8"
      elementBody={
        <div className="flex flex-col gap-1 px-6">
          <div className="flex justify-end"> 
            <Button variation="primary" size="small" onClick={() =>onToggleTab(1)}><IconButtons variant="back"/> Atrás</Button>
          </div>
            <LeadsUpdateForm id={assingLead} onToggleTab={onToggleTab} user={user} userName={userName}/>
        </div>
      }
    />
    </div>
  )
}

export default UpdateLeadForm